import { RouterModule, Routes } from '@angular/router';

import { AddressTypeCreateComponent } from './create.component';
import { AddressTypeEditComponent } from './edit.component';
import { AddressTypesListComponent } from './list.component';
import { AuthGuard } from '../auth/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AddressTypeService } from './address-type.service';

const routes: Routes = [
  {
    path: 'address-types',
    component: AddressTypesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'address-types/:id/edit',
    component: AddressTypeEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'address-types/create',
    component: AddressTypeCreateComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    AddressTypesListComponent,
    AddressTypeEditComponent,
    AddressTypeCreateComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, AddressTypeService],
})
export class AddressTypeRoutingModule {}
